module.exports = __webpack_public_path__ + "static/media/cow-with-cap.bc60d219.png";